// 预览附件功能
import Vue from 'vue'
Vue.prototype.$previewFile =  function (fileUrl) {
  if (fileUrl) {
    const addTypeArray = fileUrl.split(".");
    const fileType = addTypeArray[addTypeArray.length - 1].toLowerCase();
    if (['jpg', 'png'].includes(fileType)) {
      const fileWindow = window.open("");
      const imgStyle = 'width: auto;height: auto;max-width: 100%;max-height: 100%;position: absolute;top:50%;left:50%;transform: translate(-50%,-50%);'
      fileWindow.document.write(`<image src='${fileUrl}' style="${imgStyle}"/>`);
      // fileWindow.document.title = "附件"
    } else if (['doc', 'docx', 'xlsx', 'xls'].includes(fileType)) {
      window.open(`https://view.officeapps.live.com/op/view.aspx?src=${fileUrl}`);
    } else if (fileType == 'pdf') {
      window.open(fileUrl);
    //   const pdfWindow = window.open("");
    //   //把url转base64格式
    //   window.URL = window.URL || window.webkitURL;
    //   let xhr = new XMLHttpRequest();
    //   xhr.open("get", fileUrl, true);
    //   xhr.responseType = "blob";
    //   xhr.onload = function () {
    //     if (this.status == 200) {
    //       //得到一个blob对象
    //       let blob = this.response;
    //       let oFileReader = new FileReader();
    //       oFileReader.onloadend = function (e) {
    //         // 此处拿到的已经是base64格式了
    //         let fileBase64 = e.target.result;
    //         pdfWindow.document.write(`<embed src="${fileBase64}" type="application/pdf;chartset=UTF-8;" style="width: 100%;height: 100%"/>`);
    //         // pdfWindow.document.title = "附件"
    //       };
    //       oFileReader.readAsDataURL(blob);
    //     }
    //   }
    //   xhr.send();
    }
  }
}

